import Styled from 'styled-components';

const namespace = 'success-message';

interface SuccessMessageContainerProps {
  isMobile?: boolean;
  width?: 'string' | 'auto';
}

export const SuccessMessageContainer = Styled.div<SuccessMessageContainerProps>`
  transition: all 0.7s ease-in-out;
  width: ${(props: SuccessMessageContainerProps) => props.width || 'auto' };
  text-align: center;

  ${(props) => props.isMobile && (
    'width: auto; text-align: center; padding: 0 50px;'
  )}

  .${namespace}-gif {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 112px;
    margin: 48px 0;

    ion-img::part(image) {
      border-radius: 100px;
    }

    ${(props) => props.isMobile && (
      'display: inline-block; width: 20%; height: 60px; margin: 32px 0;'
    )}
  }

  .${namespace}-body {
    padding: 16px 0;
    text-align: center;

    ${(props) => props.isMobile && (
      'padding: 0 0 16px;'
    )}
  }

  .${namespace}-confirm {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
  }
`;